import React from 'react';
import PropTypes from 'prop-types';

const IconSortDown = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 500 1792 1792"
    >
        <path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z" />
    </svg>
);

IconSortDown.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconSortDown.defaultProps = {
    size: 17,
    fill: 'white',
};

IconSortDown.displayName = 'SortDown';

export default IconSortDown;
